import { Inject, Injectable } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from "@angular/common";
import { ClassProvider, FactoryProvider, InjectionToken, PLATFORM_ID } from '@angular/core';

/* Create a new injection token for injecting the window into a component. */
export const WINDOW = new InjectionToken<Window>(
  'WindowToken',
  typeof window !== 'undefined' && window.document ? { providedIn: 'root', factory: () => window } : undefined
);

/* Define abstract class for obtaining reference to the global window object. */
export abstract class WindowRef {

  get nativeWindow(): Window | Object {
    throw new Error('Not implemented.');
  }

}
@Injectable({
  providedIn: 'root'
})
/* Define class that implements the abstract class and returns the native window object. */
export class BrowserWindowRef extends WindowRef {
  isServer: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: string) {
    super();
    this.isServer = isPlatformServer(platformId);
  }

  get nativeWindow(): Window | Object {
    if(this.isServer) return {
      matchMedia: () => {}
    };
    return window;
    /*
    return window["$"] = $;
    return window["jQuery"] = $;
    */
  }

}

/* Create an factory function that returns the native window object. */
export function windowFactory(browserWindowRef: BrowserWindowRef, platformId: Object): Window | Object {
  if (isPlatformBrowser(platformId)) {
    return browserWindowRef.nativeWindow;
  }
  return new Object();
}

/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
const browserWindowProvider: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef
};

/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const windowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [ WindowRef, PLATFORM_ID ]
};

/* Create a injectable provider for the WindowRef token that uses the BrowserWindowRef class. */
const browserNavigatorProvider: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef
};

/* Create an injectable provider that uses the windowFactory function for returning the native window object. */
const NavigatorProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [ WindowRef, PLATFORM_ID ]
};

/* Create an array of providers. */
export const WINDOW_PROVIDERS = [
  browserWindowProvider,
  windowProvider
];

